import * as React from "react";
import SetFirstPassword from "../components/password/SetFirstPassword";
import "./InitPasswordPage.scss";
import Banner from "../components/banner/Banner";

/**
 * Stránka prvotního nastavení hesla po registraci.
 */
class InitPasswordPage extends React.Component<any> {
  handleLoginRedirect = (loginToken) => {
    window.location.href = window.appConfig.serverContextPath + "/init-password/success?token=" + loginToken;
  };

  render() {
    const urlParams = new URLSearchParams(this.props.location.search);
    const code = urlParams.get("code");
    return (
      <>
        {typeof window !== "undefined" && window.appConfig?.isTST && <Banner text="Testovací prostředí (TST)" />}
        <SetFirstPassword code={code} onLoginRedirect={this.handleLoginRedirect} />
      </>
    );
  }
}

export default InitPasswordPage;
